export default {
  menu: {
    balances: 84026, // Balances
    calendar: 70005, // Calendar
    home: 81400, // Home
    messageCenter: 83129, // Message Center
    settings: 101525, // Settings
  }
}
